/**
 * Main content area wrapper component.
 */

import { FC, ReactNode } from 'react';
import { Box, Toolbar } from '@mui/material';
import { useUIStore } from '@/stores/uiStore';
import { Breadcrumbs } from './Breadcrumbs';

interface MainContentProps {
  children: ReactNode;
}

const DRAWER_WIDTH = 240;

export const MainContent: FC<MainContentProps> = ({ children }) => {
  const { sidebarOpen } = useUIStore();

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        p: 3,
        width: { sm: `calc(100% - ${sidebarOpen ? DRAWER_WIDTH : 0}px)` },
        ml: { sm: sidebarOpen ? `${DRAWER_WIDTH}px` : 0 },
        transition: (theme) =>
          theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
      }}
    >
      <Toolbar />
      <Breadcrumbs />
      {children}
    </Box>
  );
};
